import script from "./SelectSipDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectSipDialog.vue?vue&type=script&setup=true&lang=js"

import "./SelectSipDialog.vue?vue&type=style&index=0&id=29c67deb&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29c67deb"]])

export default __exports__